export const selectNudataHasError = (state) => state?.application?.nudata?.hasError;

export const selectNudataSession = (state) => state?.application?.nudata?.session;
